<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <form class="modal-content" v-on:submit.prevent="submit">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">{{ title }}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="loading" class="block-content text-center">
                        <p class="h4 mb-4">Loading</p>
                    </div>
                    <div v-show="loading === false" class="block-content fs-sm">
                        <div class="row" v-if="submitText == 'Create'">
                            <div class="col-12 col-md-6 mb-4">
                                <label class="form-label" for="f_vehicle">Vehicle (required)</label>
                                <select class="form-select" id="f_vehicle" ref="vehiclePicker" required>
                                </select>
                            </div>
                            <div class="col-12 col-md-6 mb-4">
                                <label class="form-label" for="f_job">Job (optional)</label>
                                <select class="form-select" id="f_job" ref="jobPicker" :disabled="chosenVehicle === null">
                                </select>
                            </div>
                            <div class="col-12 mb-4">
                                <label class="form-label" for="f_staff">Staff</label>
                                <select class="form-select" id="f_staff" ref="staffPicker" required>
                                </select>
                            </div>
                        </div>

                        <div class="mb-4" v-if="timeEntryJobId === null && chosenJob === null">
                            <label class="form-label" for="f_description">Description</label>
                            <input type="text" class="form-control" :class="{'is-invalid': errors.description}" id="f_description" v-model="timeEntryDescription">

                            <div v-if="errors.description" class="invalid-feedback">{{ errors.description.join(', ') }}</div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label">Start</label>
                            <div class="row" :class="{'is-invalid': errors.start}">
                                <div class="col-6">
                                    <input type="text" class="form-control js-flatpickers" :class="{'is-invalid': errors.start}" ref="timeEntryStart" v-model="timeEntryStart.date" required />
                                </div>
                                <div class="col-6">
                                    <div class="input-group">
                                        <input type="number" min="0" max="23" class="form-control" :class="{'is-invalid': errors.start}" v-model="timeEntryStart.hour" required />
                                        <span class="input-group-text">:</span>
                                        <input type="number" min="0" max="59" class="form-control" :class="{'is-invalid': errors.start}" v-model="timeEntryStart.minute" required />
                                    </div>
                                </div>
                            </div>

                            <div v-if="errors.start" class="invalid-feedback">{{ errors.start.join(', ') }}</div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label">End</label>
                            <div class="row" :class="{'is-invalid': errors.end}">
                                <div class="col-6">
                                    <input type="text" class="form-control js-flatpickers" :class="{'is-invalid': errors.end}" ref="timeEntryEnd" v-model="timeEntryEnd.date" required />
                                </div>
                                <div class="col-6">
                                    <div class="input-group">
                                        <input type="number" min="0" max="23" class="form-control" :class="{'is-invalid': errors.end}" v-model="timeEntryEnd.hour" required />
                                        <span class="input-group-text">:</span>
                                        <input type="number" min="0" max="59" class="form-control" :class="{'is-invalid': errors.end}" v-model="timeEntryEnd.minute" required />
                                    </div>
                                </div>
                            </div>

                            <div v-if="errors.end" class="invalid-feedback">{{ errors.end.join(', ') }}</div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                        <button v-if="!loading" type="submit" class="btn btn-sm btn-success">{{ submitText }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        routes: Object,
    },
    data () {
        return {
            chosenJob: null,
            chosenStaff: null,
            chosenVehicle: null,
            errors: [],
            initialisedSelect2: false,
            timeEntryJobId: null,
            timeEntryDescription: '',
            timeEntryStart: {},
            timeEntryEnd: {},
            loading: false,
            modal: null,
            route: null,
            submitText: 'Submit',
            title: '',
        };
    },
    computed: {
        startDatePicker: vm => vm.$refs.timeEntryStart._flatpickr,
        endDatePicker: vm => vm.$refs.timeEntryEnd._flatpickr,
    },
    mounted () {
        this.modal = new Modal(this.$el);

        Eventbus.on('add-classics-timeentry', () => {
            this.errors = [];
            this.route = this.routes.create;
            this.title = 'Add Time Entry';
            this.submitText = 'Create';
            this.timeEntryJobId = null;
            this.timeEntryDescription = '';

            this.timeEntryStart = {};
            this.timeEntryEnd = {};

            this.startDatePicker.clear();
            this.endDatePicker.clear();

            this.modal.show();

            setTimeout(() => {
                if (! this.initialisedSelect2) {
                    window.jQuery(this.$refs.vehiclePicker).select2({
                        dropdownParent: this.$el,
                        placeholder: 'Select vehicle',
                        allowClear: true,
                        ajax: {
                            cache: true,
                            data: function(params) {
                                return {
                                    search: params.term,
                                    page: params.page
                                };
                            },
                            dataType: 'json',
                            delay: 250,
                            processResults: function(data) {
                                // why do we need to do this?
                                return {
                                    results: data.data
                                };
                            },
                            url: this.routes.vehicleFilter,
                        }
                    }).on('select2:select', (ev) => {
                        this.chosenVehicle = ev.params.data.id;
                        window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                    }).on('select2:clear', (ev) => {
                        this.chosenVehicle = null;
                        window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                    });

                    window.jQuery(this.$refs.jobPicker).select2({
                        dropdownParent: this.$el,
                        placeholder: 'Select job',
                        allowClear: true,
                        ajax: {
                            cache: true,
                            data: function(params) {
                                return {
                                    search: params.term,
                                    page: params.page
                                };
                            },
                            dataType: 'json',
                            delay: 250,
                            processResults: function(data) {
                                // why do we need to do this?
                                return {
                                    results: data.data
                                };
                            },
                            url: () => {
                                return this.routes.jobsFilter.replace('replace-me', this.chosenVehicle);
                            },
                        }
                    }).on('select2:select', (ev) => {
                        this.chosenJob = ev.params.data.id;
                    }).on('select2:clear', (ev) => {
                        this.chosenJob = null;
                    });

                    window.jQuery(this.$refs.staffPicker).select2({
                        dropdownParent: this.$el,
                        placeholder: 'Select staff',
                        allowClear: true,
                        ajax: {
                            cache: true,
                            data: function(params) {
                                return {
                                    search: params.term,
                                    page: params.page
                                };
                            },
                            dataType: 'json',
                            delay: 250,
                            processResults: function(data) {
                                // why do we need to do this?
                                return {
                                    results: data.data
                                };
                            },
                            url: this.routes.staffFilter,
                        }
                    }).on('select2:select', (ev) => {
                        this.chosenStaff = ev.params.data.id;
                    }).on('select2:clear', (ev) => {
                        this.chosenStaff = null;
                    });

                    this.initialisedSelect2 = true;
                }
            }, 50);
        });

        Eventbus.on('edit-classics-timeentry', (timeEntryUuid) => {
            this.chosenJob = null;
            this.chosenVehicle = null;
            this.initialisedSelect2 = false;
            this.loading = true;
            this.errors = [];
            this.route = this.routes.edit.replace('replace-me', timeEntryUuid);
            axios.get(this.route)
                .then((response) => {
                    this.title = 'Edit Time Entry';
                    this.submitText = 'Update';
                    this.timeEntryJobId = response.data.job_id;
                    this.timeEntryDescription = response.data.description;

                    this.timeEntryStart = response.data.start;
                    this.timeEntryEnd = response.data.end;

                    this.startDatePicker.jumpToDate(this.timeEntryStart.date);
                    this.endDatePicker.jumpToDate(this.timeEntryEnd.date);

                    this.loading = false;
                    this.modal.show();
                }).catch((error) => {
                    let status = 'Unknown';
                    if (error.response) {
                        status = error.response.status;
                    }

                    let text = 'System error: ' + status;

                    if (status === 400) {
                        text = 'This time entry cannot be edited';
                    }
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not edit time entry',
                        text: text,
                    });
                });
        });
    },
    methods: {
        submit () {
            // flatpickr validation is blocked
            if (this.timeEntryStart.date === undefined || this.timeEntryEnd.date === undefined) {
                return false;
            }

            let newStart = `${this.timeEntryStart.date} ${this.timeEntryStart.hour}:${this.timeEntryStart.minute}:00`;
            let newEnd = `${this.timeEntryEnd.date} ${this.timeEntryEnd.hour}:${this.timeEntryEnd.minute}:00`;

            let data = {
                description: this.timeEntryDescription,
                start: newStart,
                end: newEnd,
            };

            if (this.submitText == 'Create') {
                data.chosenJob = this.chosenJob;
                data.chosenStaff = this.chosenStaff;
                data.chosenVehicle = this.chosenVehicle;
            }

            this.loading = true;
            axios.post(this.route, data).then((response) => {
                if (response.data.success === true) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Submitted time entry',
                        timer: 1500,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    this.modal.hide();
                    Eventbus.emit('time-entries-table-refresh');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not submit time entry',
                        text: 'Unknown error',
                    });
                }
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }

                if (status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not submit time entry',
                        text: 'System error: ' + status,
                    });
                }
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>
